var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"-mb-80 lg:-mb-160"},_vm._l((_vm.projects),function(project,index){return _c('project-card',{key:project.id,attrs:{"project":project,"index":index}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }